export default __webpack_public_path__ + "static/media/logo-concept.4e1a6f4d.png";